// LoginV1 and the growth.ecomm.logged-out-loyalty-personalization-cta.rollout flag were removed
// (ECOMM-8974): LoginV2 is now the only logged-out login CTA. The "V2" naming is retained to keep
// this removal diff minimal.
export { LoginV2 as LoginCta } from './login-v2';
